module.exports = __webpack_public_path__ + "img/coin.90cf268a.png";